import React from "react";
import WhoToFollowListItem from "./WhoToFollowListItem.js";
import whos from "./who.json";


const WhoToFollowList = () => {
  return(
      <div>
          <li className={`list-group-item mt-2`}>Who to follow</li>
          <div className={`container-fluid`}>
            <ul className={`list-group wd-font-15`}>
              {
                whos.map(who=>{
                  return(
                    <WhoToFollowListItem who={who}/>
                  );
                })
              }
            </ul>
          </div>
      </div>
    );
}

export default WhoToFollowList;